import { Permission } from 'types/enums/Permission';
import type { IUser } from 'types/IUser';

/** The roles an account holds. The API sends the ids as strings (MySQL bigint). */
export const userPermissions = (user: IUser): Permission[] =>
  (user.userAccountPermissions ?? []).map((entry) => Number(entry.permissionsId) as Permission);

/**
 * Only a Super Admin may edit or delete a Super Admin account — the backend
 * refuses it for anyone else, so those actions stay hidden.
 */
export const isSuperAdminUser = (user: IUser): boolean => userPermissions(user).includes(Permission.SUPER_ADMIN);
